// extracted by mini-css-extract-plugin
export default {"AlertmessegeText":"Confirmation_AlertmessegeText__PUqUG"};